import React, { useState } from 'react';
import './AgeConfirmation.scss';
import Drawer from '../Drawer/Drawer';
import Button, { BUTTON_VARIANTS } from '../UI/Button/Button';
import { updateConfirmedAge } from '../../../api/public-voissa/users';
import { useMutation } from '@tanstack/react-query';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserShield } from '@fortawesome/free-solid-svg-icons';

const AgeConfirmation = ({ handleClose = () => {}, onSuccess = () => {} }) => {
    const [error, setError] = useState(false);
    
    const { isLoading: isLoadingConfirmedAge, mutate: mutateConfirmedAge } = useMutation(updateConfirmedAge, {
        onSuccess: async () => {
            onSuccess();
            window.location.reload();
        },
        onError: () => {
            setError(true);
        }
    });

    const handleConfirm = async () => {
        setError(false);
        mutateConfirmedAge();
    };

    return (
        <Drawer open={true} handleClose={handleClose} large>
            <div className="age-confirmation">
                <div className="age-confirmation-header">
                    <FontAwesomeIcon icon={faUserShield} className="age-confirmation-icon" />
                    <h2 className="age-confirmation-title">Contenu réservé aux adultes</h2>
                </div>
                <div className="age-confirmation-content">
                    <p className="age-confirmation-text">
                        La loi française impose de vérifier votre majorité par un tiers de confiance.
                    </p>
                    <p className="age-confirmation-text">
                        Dans les prochains jours nous vous proposerons des solutions techniques pour le faire.
                    </p>
                    <p className="age-confirmation-text">
                        Des solutions simples et rapides vous seront proposées très bientôt.
                    </p>
                    <p className="age-confirmation-text">
                        Nous vous remercions de votre compréhension.
                    </p>
                    {error && <p className="age-confirmation-error">Impossible de confirmer votre âge.</p>}
                </div>

                <div className="age-confirmation-buttons">
                    <Button 
                        variant={BUTTON_VARIANTS.REVERSE} 
                        onClick={handleConfirm} 
                        big 
                        full
                        loading={isLoadingConfirmedAge}
                    >
                        Je suis majeur(e)
                    </Button>
                    <Button 
                        variant={BUTTON_VARIANTS.PRIMARY} 
                        onClick={handleClose} 
                        big 
                        full
                    >
                        Peut-être plus tard
                    </Button>
                </div>
            </div>
        </Drawer>
    );
};

export default AgeConfirmation;
